import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import numbro from 'numbro';

import { BREAD_PRICES } from '../../../constants/currencies';
import { currencyNames } from '../../../constants/exchangeRates';
import { SVGIconType } from '../../../constants/svgIcon';
import { PngIcon, SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './GetCustomBreadPopup.module.css';

type GetCustomBreadPopupProps = {
  currency?: 'USD' | 'HKD' | 'CNY' | 'TWD';
  onPrimary: (bread: number) => void;
  onCancel: () => void;
};

export const GetCustomBreadPopup = (props: GetCustomBreadPopupProps) => {
  const { currency = 'USD', onPrimary, onCancel } = props;
  const { t } = useTranslation();

  const [amount, setAmount] = useState(200000);
  const price =
    currencyNames[currency] +
    numbro((BREAD_PRICES[currency] * amount) / 100 / 100).format({
      thousandSeparated: true,
    });

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('Continue')}
      onPrimaryButtonClick={() => onPrimary(amount)}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.popupContent}>
        <div>
          <SvgIcon
            name={SVGIconType.BreadDonate}
            width={80}
            height={80}
            color="#333333"
          />
          <div className={styles.title}>{t('Get More Bread')}</div>
          <div className={styles.description}>
            {t('Help provide more bread to those in need.')}
          </div>
        </div>
        <div className={styles.adjustBar}>
          {/* note that the plus and minus png has some transparent padding so a cyan background with border radius is still used  */}
          <div
            className={styles.adjustButton}
            onClick={() => setAmount((a) => Math.max(10000, a - 10000))}
          >
            <PngIcon name="CircleMinus" width={32} height={32} />
            {amount === 10000 && <div className={styles.disabled} />}
          </div>
          <div className={styles.adjustBarContent}>
            <PngIcon name="Bread" width={22} height={22} />
            {numbro(amount).format({ thousandSeparated: true })}
          </div>
          <div
            className={styles.adjustButton}
            onClick={() => setAmount((a) => Math.min(99990000, a + 10000))}
          >
            <PngIcon name="CirclePlus" width={32} height={32} />
            {amount === 99990000 && <div className={styles.disabled} />}
          </div>
        </div>
        <div className={styles.priceBox}>
          <div>{t('Pay: ')}</div>
          <div className={styles.price}>{price}</div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
